import {
  GetPublishedTracksRequest,
  GetPublishedTracksResponse,
  GetTrackFilesRequest,
  GetTrackFilesResponse,
  GetTrackRequest,
  GetTrackResponse,
  GetTrackVersionsRequest,
  GetTrackVersionsResponse,
  PostTrackBatchRequest,
  PostTrackBatchResponse,
  PostTrackFileRequest,
  PostTrackFileResponse,
  PostTrackRequest,
  PostTrackResponse,
  SendInviteRequest,
  SendInviteResponse,
  Track,
  Collaborator,
  TrackFile,
  TrackProcessorInfo,
  DeleteTrackFileResponse,
  DeleteTrackFileRequest,
  DeleteTrackVersionRequest,
  DeleteTrackVersionResponse,
  GetAssetSizeResponse,
  GetAssetSizeRequest,
  InviteTemplateMap,
  InvitedCollaborator,
  GetMyTracksResponse,
  TrackFilters,
  GetMyTracksRequest,
  GetUserTrackVersionsRequest,
  GetUserTrackVersionsResponse,
  GetAssetCountResponse,
  GetAssetCountRequest,
  GetTotalTracksAndFilesCountResponse,
  GetTotalTracksAndFilesCountRequest,
  GetFolderArtworkRequest,
} from "../proto/api_pb";
import {
  PostTrackVersionRequest,
  PostTrackVersionResponse,
  TrackVersion,
} from "../proto/api_pb";
import { OmmuseClient } from "../proto/api_grpc_web_pb";
import { RpcError } from "grpc-web";
import { backOff } from "exponential-backoff";
import { TrackFilterParams } from "../pages/MyTracks/types";
import { getSortByValue } from "../pages/MyTracks/utils";
import { versionStateForFilter } from "../pages/Tracks/types";

export const sendInvites = async (
  token: string,
  inviteList: string[],
  userIdsList: string[],
  inviterId: string,
  url?: string,
  name?: string,
  templateEnum?: InviteTemplateMap[keyof InviteTemplateMap]
): Promise<SendInviteResponse | RpcError> => {
  const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
  const request = new SendInviteRequest();
  request.setInviterUserId(inviterId);
  if (userIdsList.length !== 0) request.setInvitedUserIdsList(userIdsList);
  if (inviteList.length !== 0) request.setEmailsList(inviteList);
  if (url) request.setObjectUrl(url);
  if (name) request.setObjectName(name);
  if (templateEnum) request.setInviteTemplate(templateEnum);

  const metadata = {
    Authorization: `${token}`,
    "Access-Control-Allow-Origin": "*",
  };
  return await backOff(
    () =>
      new Promise<SendInviteResponse | RpcError>((resolve, reject) => {
        ommuseClient.sendInvite(request, metadata, function (err, response) {
          if (err) {
            console.log(err.code);
            console.log(err.message);
            reject(err);
          } else {
            resolve(response);
          }
        });
      }),
    {
      numOfAttempts: 3,
      jitter: "full",
    }
  );
};

export const postTrack = async (
  track: Track,
  token: string,
  userId: string
): Promise<PostTrackResponse | RpcError> => {
  const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
  const request = new PostTrackRequest();
  request.setLastUpdatedBy(userId);
  request.setTrack(track);
  const metadata = {
    Authorization: `${token}`,
    "Access-Control-Allow-Origin": "*",
  };
  return await backOff(
    () =>
      new Promise<PostTrackResponse | RpcError>((resolve, reject) => {
        ommuseClient.postTrack(request, metadata, function (err, response) {
          if (err) {
            console.log(err.code);
            console.log(err.message);
            reject(err);
          } else {
            resolve(response);
          }
        });
      }),
    {
      numOfAttempts: 3,
      jitter: "full",
    }
  );
};

export const postTrackBatch = async (
  trackProcessorInfosList: Array<TrackProcessorInfo>,
  artist: string,
  album: string,
  collaboratorsList: Array<Collaborator>,
  inviteCollabList: InvitedCollaborator[],
  ownerId: string,
  imageUrl: string,
  genre: string[],
  moods: string[],
  token: string,
  enterpriseId?: string,
): Promise<PostTrackBatchResponse | RpcError> => {
  const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
  const request = new PostTrackBatchRequest();
  request.setArtist(artist);
  request.setAlbum(album);
  request.setCollaboratorsList(collaboratorsList);
  request.setGenreList(genre);
  request.setMoodsList(moods);
  request.setImageUrl(imageUrl);
  request.setOwnerId(ownerId);
  if (enterpriseId) request.setEnterpriseId(enterpriseId);
  request.setTrackProcessorInfosList(trackProcessorInfosList);
  if (inviteCollabList.length !== 0)
    request.setInvitedCollaboratorsList(inviteCollabList);
  const metadata = {
    Authorization: `${token}`,
    "Access-Control-Allow-Origin": "*",
  };
  return await backOff(
    () =>
      new Promise<PostTrackBatchResponse | RpcError>((resolve, reject) => {
        ommuseClient.postTrackBatch(
          request,
          metadata,
          function (err, response) {
            if (err) {
              console.log(err.code);
              console.log(err.message);
              reject(err);
            } else {
              resolve(response);
            }
          }
        );
      }),
    {
      numOfAttempts: 3,
      jitter: "full",
    }
  );
};

export const postBatchInitial = async (
  trackProcessorInfosList: Array<TrackProcessorInfo>,
  ownerId: string,
  token: string
): Promise<PostTrackBatchResponse | RpcError> => {
  const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
  const request = new PostTrackBatchRequest();
  request.setOwnerId(ownerId);
  request.setTrackProcessorInfosList(trackProcessorInfosList);
  const metadata = {
    Authorization: `${token}`,
    "Access-Control-Allow-Origin": "*",
  };
  return await backOff(
    () =>
      new Promise<PostTrackBatchResponse | RpcError>((resolve, reject) => {
        ommuseClient.postTrackBatch(
          request,
          metadata,
          function (err, response) {
            if (err) {
              console.log(err.code);
              console.log(err.message);
              reject(err);
            } else {
              console.log(response);
              resolve(response);
            }
          }
        );
      }),
    {
      numOfAttempts: 3,
      jitter: "full",
    }
  );
};

export const postTrackVersion = async (
  trackVersion: TrackVersion,
  token: string,
  userId: string,
  enterpriseId?: string
): Promise<PostTrackVersionResponse | RpcError> => {
  const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
  const request = new PostTrackVersionRequest();
  request.setTrackVersion(trackVersion);
  request.setLastUpdatedBy(userId);
  if (enterpriseId) request.setEnterpriseId(enterpriseId)
  const metadata = {
    Authorization: `${token}`,
    "Access-Control-Allow-Origin": "*",
  };
  return await backOff(
    () =>
      new Promise<PostTrackVersionResponse | RpcError>((resolve, reject) => {
        ommuseClient.postTrackVersion(
          request,
          metadata,
          function (err, response) {
            if (err) {
              console.log(err.code);
              console.log(err.message);
              reject(err);
            } else {
              resolve(response);
            }
          }
        );
      }),
    {
      numOfAttempts: 3,
      jitter: "full",
    }
  );
};

export const postTrackFile = async (
  trackFile: TrackFile,
  token: string,
  enterpriseId: string | undefined
): Promise<PostTrackFileResponse | RpcError> => {
  const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
  const request = new PostTrackFileRequest();
  request.setTrackFile(trackFile);
  if (enterpriseId) request.setEnterpriseId(enterpriseId)
  const metadata = {
    Authorization: `${token}`,
    "Access-Control-Allow-Origin": "*",
  };
  return await backOff(
    () =>
      new Promise<PostTrackFileResponse | RpcError>((resolve, reject) => {
        ommuseClient.postTrackFile(request, metadata, function (err, response) {
          if (err) {
            console.log(err.code);
            console.log(err.message);
            reject(err);
          } else {
            resolve(response);
          }
        });
      }),
    {
      numOfAttempts: 3,
      jitter: "full",
    }
  );
};

export const deleteTrackFile = async (
  fileId: string,
  token: string,
  enterpriseId: string | undefined
): Promise<DeleteTrackFileResponse | RpcError> => {
  const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
  const request = new DeleteTrackFileRequest();
  request.setId(fileId);
  if (enterpriseId) request.setEnterpriseId(enterpriseId)
  const metadata = {
    Authorization: `${token}`,
    "Access-Control-Allow-Origin": "*",
  };
  return await backOff(
    () =>
      new Promise<DeleteTrackFileResponse | RpcError>((resolve, reject) => {
        ommuseClient.deleteTrackFile(
          request,
          metadata,
          function (err, response) {
            if (err) {
              console.log(err.code);
              console.log(err.message);
              reject(err);
            } else {
              resolve(response);
            }
          }
        );
      }),
    {
      numOfAttempts: 3,
      jitter: "full",
    }
  );
};

export const deleteTrackVersion = async (
  versionId: string,
  token: string,
  enterpriseId: string | undefined
): Promise<DeleteTrackVersionResponse | RpcError> => {
  const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
  const request = new DeleteTrackVersionRequest();
  request.setId(versionId);
  if (enterpriseId) request.setEnterpriseId(enterpriseId)
  const metadata = {
    Authorization: `${token}`,
    "Access-Control-Allow-Origin": "*",
  };
  return await backOff(
    () =>
      new Promise<DeleteTrackVersionResponse | RpcError>((resolve, reject) => {
        ommuseClient.deleteTrackVersion(
          request,
          metadata,
          function (err, response) {
            if (err) {
              console.log(err.code);
              console.log(err.message);
              reject(err);
            } else {
              resolve(response);
            }
          }
        );
      }),
    {
      numOfAttempts: 3,
      jitter: "full",
    }
  );
};

export const fetchTracks = async (
  token: string,
  TrackFilterParams: TrackFilterParams,
  queryValue?: string,
  projectId?: string,
  enterpriseId?: string,
  role?: number,
  folderId?: string,
): Promise<GetMyTracksResponse | RpcError> => {
  const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
  const request = new GetMyTracksRequest();
  const isSharePage = window.location.pathname.includes("/share/");
  if (projectId) {
    request.setProjectId(projectId)
  }
  if (enterpriseId) {
    request.setEnterpriseId(enterpriseId)
  }
  if (role) {
    request.setRole(role)
  }
  if (folderId) {
    request.setFolderId(folderId)
  }
  const filters = new TrackFilters();
  filters.setArtistsList(TrackFilterParams.artistList ?? []);
  filters.setUserIdsList(TrackFilterParams.userIds);
  filters.setGenreList(TrackFilterParams.genreList ?? []);
  filters.setCollaboratorsList(TrackFilterParams.collaboratorsList ?? []);
  filters.setTrackPrivacy(TrackFilterParams.TrackPrivacy ?? "");
  filters.setBpmStartValue(TrackFilterParams.bpmStartValue ?? 0);
  filters.setBpmEndValue(TrackFilterParams.bpmEndValue ?? 500);
  filters.setIsCompletedTracks(TrackFilterParams.isCompletedTracks)
  if (TrackFilterParams.status === "") {
    filters.setStatus("");
  } else {
    filters.setStatus(
      versionStateForFilter[Number(TrackFilterParams.status)] ?? ""
    );
  }
  request.setSortby(getSortByValue(TrackFilterParams.sortBy));
  request.setIsAscending(TrackFilterParams.isAscending ?? false);
  request.setPage(TrackFilterParams.page ?? 0);
  request.setLimit(TrackFilterParams.limit ?? 8);
  request.setFilters(filters);
  request.setIsSharedPage(isSharePage);
  if (queryValue) request.setQuery(queryValue ?? "");
  const metadata = {
    Authorization: `${token}`,
    "Access-Control-Allow-Origin": "*",
  };
  return await backOff(
    () =>
      new Promise<GetMyTracksResponse | RpcError>((resolve, reject) => {
        ommuseClient.getMyTracks(request, metadata, function (err, response) {
          if (err) {
            reject(err);
          } else {
            resolve(response);
          }
        });
      }),
    {
      numOfAttempts: 3,
      jitter: "full",
    }
  );
};

export const getFolderArtwork = async (
  token: string,
  folderId: string,
  enterpriseId: string,
): Promise<string> => {
  const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
  const request = new GetFolderArtworkRequest();
  request.setFolderId(folderId);
  request.setEnterpriseId(enterpriseId);
  const metadata = {
    Authorization: `${token}`,
    "Access-Control-Allow-Origin": "*",
  };
  return new Promise<string>((resolve) => {
    ommuseClient.getFolderArtwork(request, metadata, function (err, response) {
      if (err || !response) {
        resolve("");
      } else {
        resolve(response.getArtworkUrl());
      }
    });
  });
};

export const fetchTrack = async (
  token: string,
  id: string
): Promise<RpcError | GetTrackResponse | undefined> => {
  try {
    const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
    const request = new GetTrackRequest();
    request.setId(id);
    const metadata = {
      Authorization: `${token}`,
      "Access-Control-Allow-Origin": "*",
    };
    return await backOff(
      () =>
        new Promise<GetTrackResponse | RpcError>((resolve, reject) => {
          ommuseClient.getTrack(request, metadata, function (err, response) {
            if (err) {
              reject(err);
            } else {
              resolve(response);
            }
          });
        }),
      {
        numOfAttempts: 3,
        jitter: "full",
      }
    );
  } catch (e) {
    console.log(e);
  }
};

export const fetchTrackVersions = async (
  token: string,
  id: string
): Promise<RpcError | GetTrackVersionsResponse | undefined> => {
  try {
    const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
    const request = new GetTrackVersionsRequest();
    request.setTrackId(id);
    const metadata = {
      Authorization: `${token}`,
      "Access-Control-Allow-Origin": "*",
    };
    return await backOff(
      () =>
        new Promise<GetTrackVersionsResponse | RpcError>((resolve, reject) => {
          ommuseClient.getTrackVersions(
            request,
            metadata,
            function (err, response) {
              if (err) {
                reject(err);
              } else {
                resolve(response);
              }
            }
          );
        }),
      {
        numOfAttempts: 3,
        jitter: "full",
      }
    );
  } catch (e) {
    console.log(e);
  }
};

export const fetchMasteredVersions = async (
  token: string,
  userId: string
): Promise<RpcError | GetUserTrackVersionsResponse | undefined> => {
  try {
    const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
    const request = new GetUserTrackVersionsRequest();
    request.setUserId(userId);
    const metadata = {
      Authorization: `${token}`,
      "Access-Control-Allow-Origin": "*",
    };
    return await backOff(
      () =>
        new Promise<GetUserTrackVersionsResponse | RpcError>(
          (resolve, reject) => {
            ommuseClient.getUserTrackVersions(
              request,
              metadata,
              function (err, response) {
                if (err) {
                  reject(err);
                } else {
                  resolve(response);
                }
              }
            );
          }
        ),
      {
        numOfAttempts: 3,
        jitter: "full",
      }
    );
  } catch (e) {
    console.log(e);
  }
};

export const fetchTrackFiles = async (
  token: string,
  id: string,
  userId: string
): Promise<RpcError | GetTrackFilesResponse | undefined> => {
  try {
    const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
    const request = new GetTrackFilesRequest();
    request.setTrackId(id);
    request.setUserId(userId);
    const metadata = {
      Authorization: `${token}`,
      "Access-Control-Allow-Origin": "*",
    };
    return await backOff(
      () =>
        new Promise<GetTrackFilesResponse | RpcError>((resolve, reject) => {
          ommuseClient.getTrackFiles(
            request,
            metadata,
            function (err, response) {
              if (err) {
                reject(err);
              } else {
                resolve(response);
              }
            }
          );
        }),
      {
        numOfAttempts: 3,
        jitter: "full",
      }
    );
  } catch (e) {
    console.log(e);
  }
};

export const getAssetSize = async (
  token: string,
  url: string
): Promise<RpcError | GetAssetSizeResponse | undefined> => {
  try {
    const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
    const request = new GetAssetSizeRequest();
    request.setUrl(url);
    const metadata = {
      Authorization: `${token}`,
      "Access-Control-Allow-Origin": "*",
    };
    return await backOff(
      () =>
        new Promise<GetAssetSizeResponse | RpcError>((resolve, reject) => {
          ommuseClient.getAssetSize(
            request,
            metadata,
            function (err, response) {
              if (err) {
                reject(err);
              } else {
                resolve(response);
              }
            }
          );
        }),
      {
        numOfAttempts: 3,
        jitter: "full",
      }
    );
  } catch (e) {
    console.log(e);
  }
};

export const fetchUserTrackFiles = async (
  token: string,
  id: string,
  folderId?: string | undefined,
  trackId?: string | undefined
): Promise<RpcError | GetTrackFilesResponse | undefined> => {
  try {
    const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
    const request = new GetTrackFilesRequest();
    request.setUserId(id);
    request.setFolderId(folderId!);
    request.setTrackId(trackId!);
    const metadata = {
      Authorization: `${token}`,
      "Access-Control-Allow-Origin": "*",
    };
    return await backOff(
      () =>
        new Promise<GetTrackFilesResponse | RpcError>((resolve, reject) => {
          ommuseClient.getTrackFiles(
            request,
            metadata,
            function (err, response) {
              if (err) {
                reject(err);
              } else {
                resolve(response);
              }
            }
          );
        }),
      {
        numOfAttempts: 3,
        jitter: "full",
      }
    );
  } catch (e) {
    console.log(e);
  }
};

export const getPublishedTrack = async (
  page: number,
  limit: number,
  genre: string[],
  sortBy: string,
  isFeaturedArtistTrack: boolean,
  userId: string | undefined,
  queryValue: string
): Promise<RpcError | GetPublishedTracksResponse | undefined> => {
  const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
  const request = new GetPublishedTracksRequest();
  if (userId) request.setUserId(userId);
  request.setLimit(limit);
  request.setPage(page);
  request.setGenreList(genre);
  request.setSortby(getSortByValue(sortBy));
  request.setIsFeaturedArtistTrack(isFeaturedArtistTrack);
  request.setQuery(queryValue ?? "");
  const metadata = {
    "Access-Control-Allow-Origin": "*",
  };

  return await backOff(
    () =>
      new Promise<GetPublishedTracksResponse | RpcError>((resolve, reject) => {
        ommuseClient.getPublishedTracks(
          request,
          metadata,
          function (err, response) {
            if (err) {
              reject(err);
            } else {
              resolve(response);
            }
          }
        );
      }),
    {
      numOfAttempts: 3,
      jitter: "full",
    }
  );
};

export const getTotalTracksCount = async (
  token: string,
  userId: string,
  enterpriseId?: string,
): Promise<RpcError | GetTotalTracksAndFilesCountResponse | undefined> => {
  const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
  const request = new GetTotalTracksAndFilesCountRequest();
  if (userId) request.setUserId(userId);
  if (enterpriseId) request.setEnterpriseId(enterpriseId);
  const metadata = {
    Authorization: `${token}`,
    "Access-Control-Allow-Origin": "*",
  };

  return await backOff(
    () =>
      new Promise<GetTotalTracksAndFilesCountResponse | RpcError>((resolve, reject) => {
        ommuseClient.getTotalTracksAndFilesCount(
          request,
          metadata,
          function (err, response) {
            if (err) {
              reject(err);
            } else {
              resolve(response);
            }
          }
        );
      }),
    {
      numOfAttempts: 3,
      jitter: "full",
    }
  );
};

export const getAssetsCount = async (
  token: string,
  projectId?: string,
  folderId?: string,
): Promise<RpcError | GetAssetCountResponse | undefined> => {
  const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
  const request = new GetAssetCountRequest();
  if (folderId) request.setFolderId(folderId);
  if (projectId) request.setProjectId(projectId);
  const metadata = {
    Authorization: `${token}`,
    "Access-Control-Allow-Origin": "*",
  };

  return await backOff(
    () =>
      new Promise<GetAssetCountResponse | RpcError>((resolve, reject) => {
        ommuseClient.getAssetCount(
          request,
          metadata,
          function (err, response) {
            if (err) {
              reject(err);
            } else {
              resolve(response);
            }
          }
        );
      }),
    {
      numOfAttempts: 3,
      jitter: "full",
    }
  );
};

export const formatFileSize = (sizeInGB: number): string => {
  if (sizeInGB >= 1000) {
    return sizeInGB / 1000 + " TB";
  } else if (sizeInGB >= 1) {
    // not showing .00 for the case of nums with no decimal
    if (sizeInGB % 1 === 0) {
      return sizeInGB + " GB";
    }
    return sizeInGB.toFixed(2) + " GB";
  } else if (sizeInGB >= 0.001) {
    const sizeInMB = (sizeInGB * 1024).toFixed(1);
    return sizeInMB + " MB";
  } else if (sizeInGB >= 0.000001) {
    const sizeInKB = (sizeInGB * 1024 * 1024).toFixed(0);
    return sizeInKB + " KB";
  } else {
    const sizeInB = (sizeInGB * 1024 * 1024 * 1024).toFixed(0);
    return sizeInB + " B";
  }
};
